import { reportsApi } from '@/api/reports';
import { ReportData } from '@/components/preview/types';
import { toast } from 'sonner';
import { INITIAL_FORM_DATA } from '../constants';
import { normalizeReportData } from './normalizeReportData';

export const loadReport = async (reportId: ReportData['id']): Promise<ReportData> => {
    if (!reportId) return INITIAL_FORM_DATA as ReportData;

    try {
        const report = await reportsApi.getById(reportId);
        return normalizeReportData(report);
    } catch (error) {
        toast.error('Erro ao carregar o laudo');
        console.error(error);
        return INITIAL_FORM_DATA as ReportData;
    }
};
